import { useUI } from "providers/UIProvider"

import { Flex, Text } from "@chakra-ui/react"

import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import CarNumberBox from "components/UI/molecules/CarNumberBox"
import Modal from "components/UI/organisms/Modal"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"

const CancelReservationModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { handleCancelReservation, cancelReservationLoading, currentReservation: reservation } = useReservationsContext()
  return (
    <Modal
      isOpen={modals.cancelReservationModal.isOpened}
      onClose={() => toggleModal("cancelReservationModal", false)}
      styles={{
        width: "500px",
        bodyPadding: "40px 37px",
      }}
    >
      <Flex
        flexDirection={"column"}
        alignItems="center"
        justifyContent={"center"}
      >
        <Text mb={"37px"} fontSize={"20px"}>
          {T("booking.cancel.modal")}
        </Text>
        <Flex
          alignItems={"center"}
          justifyContent="center"
          flexDirection={"column"}
          mb="41px"
        >
          <Text fontSize={"18px"}>{reservation?.vehicleModel} {`(${reservation?.vehicleBodyType})`}</Text>
          <CarNumberBox height="40px" width="170px" title={reservation?.vehicleGovNumber} />
        </Flex>
        <Flex flexDirection={"column"} gap="36px">
          <Button
            text={T("booking.cancel.modal.loundry.reason")}
            onClick={() => handleCancelReservation(6)}
            variant="solid_dark_gray"
            leftIcon={
              <Flex
                h={"40px"}
                w="40px"
                alignItems="center"
                justifyContent="center"
                background={"white"}
                borderRadius="50%"
              >
                <Icon
                  name="warehouse"
                  iconStyles={{
                    width: "20px",
                    height: "20px",
                    fill: "#7D90A8",
                  }}
                />
              </Flex>
            }
            styles={{ width: "419px", height: "80px", fontSize: "20px" }}
            isDisabled={cancelReservationLoading}
          />
          <Button
            text={T("booking.cancel.modal.user.reason")}
            onClick={() => handleCancelReservation(5)}
            variant="solid_dark_gray"
            leftIcon={
              <Flex
                h={"40px"}
                w="40px"
                alignItems="center"
                justifyContent="center"
                background={"white"}
                borderRadius="50%"
              >
                <Icon
                  name="user"
                  iconStyles={{
                    width: "20px",
                    height: "20px",
                    fill: "#7D90A8",
                  }}
                />
              </Flex>
            }
            styles={{ width: "419px", height: "80px", fontSize: "20px" }}
            isDisabled={cancelReservationLoading}
          />
        </Flex>
      </Flex>
    </Modal>
  )
}

export default CancelReservationModal
